<template>
  <div>
    <!-- 优惠信息栏 -->
    <Discount
      v-show="showDiscount"
      :coupons="coupons"
      :discountAmount="discountAmount"
      :choiceCouponMoney="choiceCouponMoney"
      :loading="loading"
      :couponsLoading="couponsLoading"
      :countdownData="countdownData"
      @click="switchPaymentDetail"
    />
    <!-- 优惠明细弹窗 -->
    <PaymentDetail
      v-model="showPaymentDetail"
      :amount="amount"
      :discountAmount="discountAmount"
      :couponAfterMoney="couponAfterMoney"
      :selectedCoupons="selectedCoupons"
      :choiceCouponMoney="choiceCouponMoney"
      :loading="loading"
      :countdownData="countdownData"
      @switchCouponList="switchCouponList"
    />
    <!-- 优惠券选择弹窗 -->
    <CouponListPopup
      v-model="showCouponListPopup"
      :coupons="allCoupons"
      :couponAfterMoney="couponAfterMoney"
      @onSelectedCoupons="onSelectedCoupons"
    />
  </div>
</template>
<script>
  // 优惠券-新版
  import Discount from './Discount'
  import PaymentDetail from './PaymentDetail'
  import CouponListPopup from './CouponList'
  import couponMixins from './couponMixins'
  import { isNewGenshin } from './utils'

  export default {
    mixins: [couponMixins],
    components: {
      Discount,
      PaymentDetail,
      CouponListPopup,
    },
    data() {
      return {
        showPaymentDetail: false,
        showCouponListPopup: false,
      }
    },
    computed: {
      showDiscount() {
        // 是否展示优惠信息栏
        // 注意：开放其他游戏时需要注意没有商品的游戏
        const { originalPrice = 0 } = this.hackSelectedSkuInfo
        const { channelPrice = 0 } = this.hackSelectedPaymentInfo
        const clen = this.gameCouponList.length
        const noCoupon = clen === 0 && originalPrice === channelPrice

        // 新版原神，未登录情况下展示
        if (isNewGenshin(this.gameName) && !this.isLogin) return true

        // 没有配置支付通道或者配置的支付通道金额为0时，不展示
        // 当前游戏没有可用优惠券 并且 商品原价=商品配置价格时，不展示
        if (channelPrice === 0 || noCoupon) return false

        // 未登录 折扣为0 不显示
        if (!this.isLogin && this.discountAmount == 0) return false

        // 已登录 未选中优惠券 && 折扣为0 不显示
        if (
          this.isLogin &&
          this.discountAmount == 0 &&
          this.gameCouponList.length === 0
        )
          return false
        const propsShow = !this.showPaymentDetail && !this.showCouponListPopup
        return propsShow
      },
    },
    watch: {
      showDiscount: {
        handler(val) {
          this.$emit('onShowDiscount', val)
          this['detail/setShowDiscount'](val)
        },
        immediate: true,
      },
    },
    methods: {
      switchCouponList() {
        if (!this.isLogin) return
        if (this.gameCouponList.length === 0) return

        this.showCouponListPopup = !this.showCouponListPopup
      },
      switchPaymentDetail() {
        // if (this.isRuPubgm) return
        if (this.isGenshin) return
        this.showPaymentDetail = true
      },
    },
  }
</script>
